var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
if (typeof Object.assign != "function") {
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) {
      if (target == null) {
        throw new TypeError("Cannot convert undefined or null to object");
      }
      var to = Object(target);
      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];
        if (nextSource != null) {
          for (var nextKey in nextSource) {
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}
if (typeof Array.from != "function") {
  Array.from = function(object) {
    return [].slice.call(object);
  };
}
var buildElement = function(str) {
  var tmp = document.implementation.createHTMLDocument("");
  tmp.body.innerHTML = str;
  return Array.from(tmp.body.children)[0];
};
var triggerEvent = function(el, name) {
  var event2 = document.createEvent("HTMLEvents");
  event2.initEvent(name, true, false);
  el.dispatchEvent(event2);
};
var definePinchZoom = function() {
  var PinchZoom2 = function(el, options) {
    this.el = el;
    this.zoomFactor = 1;
    this.lastScale = 1;
    this.offset = {
      x: 0,
      y: 0
    };
    this.initialOffset = {
      x: 0,
      y: 0
    };
    this.options = Object.assign({}, this.defaults, options);
    this.setupMarkup();
    this.bindEvents();
    this.update();
    if (this.isImageLoaded(this.el)) {
      this.updateAspectRatio();
      this.setupOffsets();
    }
    this.enable();
  }, sum = function(a, b) {
    return a + b;
  }, isCloseTo = function(value, expected) {
    return value > expected - 0.01 && value < expected + 0.01;
  };
  PinchZoom2.prototype = {
    defaults: {
      tapZoomFactor: 2,
      zoomOutFactor: 1.3,
      animationDuration: 300,
      maxZoom: 4,
      minZoom: 0.5,
      draggableUnzoomed: true,
      lockDragAxis: false,
      setOffsetsOnce: false,
      use2d: true,
      zoomStartEventName: "pz_zoomstart",
      zoomUpdateEventName: "pz_zoomupdate",
      zoomEndEventName: "pz_zoomend",
      dragStartEventName: "pz_dragstart",
      dragUpdateEventName: "pz_dragupdate",
      dragEndEventName: "pz_dragend",
      doubleTapEventName: "pz_doubletap",
      verticalPadding: 0,
      horizontalPadding: 0,
      onZoomStart: null,
      onZoomEnd: null,
      onZoomUpdate: null,
      onDragStart: null,
      onDragEnd: null,
      onDragUpdate: null,
      onDoubleTap: null
    },
    /**
     * Event handler for 'dragstart'
     * @param event
     */
    handleDragStart: function(event2) {
      triggerEvent(this.el, this.options.dragStartEventName);
      if (typeof this.options.onDragStart == "function") {
        this.options.onDragStart(this, event2);
      }
      this.stopAnimation();
      this.lastDragPosition = false;
      this.hasInteraction = true;
      this.handleDrag(event2);
    },
    /**
     * Event handler for 'drag'
     * @param event
     */
    handleDrag: function(event2) {
      var touch = this.getTouches(event2)[0];
      this.drag(touch, this.lastDragPosition);
      this.offset = this.sanitizeOffset(this.offset);
      this.lastDragPosition = touch;
    },
    handleDragEnd: function() {
      triggerEvent(this.el, this.options.dragEndEventName);
      if (typeof this.options.onDragEnd == "function") {
        this.options.onDragEnd(this, event);
      }
      this.end();
    },
    /**
     * Event handler for 'zoomstart'
     * @param event
     */
    handleZoomStart: function(event2) {
      triggerEvent(this.el, this.options.zoomStartEventName);
      if (typeof this.options.onZoomStart == "function") {
        this.options.onZoomStart(this, event2);
      }
      this.stopAnimation();
      this.lastScale = 1;
      this.nthZoom = 0;
      this.lastZoomCenter = false;
      this.hasInteraction = true;
    },
    /**
     * Event handler for 'zoom'
     * @param event
     */
    handleZoom: function(event2, newScale) {
      var touchCenter = this.getTouchCenter(this.getTouches(event2)), scale = newScale / this.lastScale;
      this.lastScale = newScale;
      this.nthZoom += 1;
      if (this.nthZoom > 3) {
        this.scale(scale, touchCenter);
        this.drag(touchCenter, this.lastZoomCenter);
      }
      this.lastZoomCenter = touchCenter;
    },
    handleZoomEnd: function() {
      triggerEvent(this.el, this.options.zoomEndEventName);
      if (typeof this.options.onZoomEnd == "function") {
        this.options.onZoomEnd(this, event);
      }
      this.end();
    },
    /**
     * Event handler for 'doubletap'
     * @param event
     */
    handleDoubleTap: function(event2) {
      var center = this.getTouches(event2)[0], zoomFactor = this.zoomFactor > 1 ? 1 : this.options.tapZoomFactor, startZoomFactor = this.zoomFactor, updateProgress = (function(progress) {
        this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
      }).bind(this);
      if (this.hasInteraction) {
        return;
      }
      this.isDoubleTap = true;
      if (startZoomFactor > zoomFactor) {
        center = this.getCurrentZoomCenter();
      }
      this.animate(this.options.animationDuration, updateProgress, this.swing);
      triggerEvent(this.el, this.options.doubleTapEventName);
      if (typeof this.options.onDoubleTap == "function") {
        this.options.onDoubleTap(this, event2);
      }
    },
    /**
     * Compute the initial offset
     *
     * the element should be centered in the container upon initialization
     */
    computeInitialOffset: function() {
      this.initialOffset = {
        x: -Math.abs(this.el.offsetWidth * this.getInitialZoomFactor() - this.container.offsetWidth) / 2,
        y: -Math.abs(this.el.offsetHeight * this.getInitialZoomFactor() - this.container.offsetHeight) / 2
      };
    },
    /**
     * Reset current image offset to that of the initial offset
     */
    resetOffset: function() {
      this.offset.x = this.initialOffset.x;
      this.offset.y = this.initialOffset.y;
    },
    /**
     * Determine if image is loaded
     */
    isImageLoaded: function(el) {
      if (el.nodeName === "IMG") {
        return el.complete && el.naturalHeight !== 0;
      } else {
        return Array.from(el.querySelectorAll("img")).every(this.isImageLoaded);
      }
    },
    setupOffsets: function() {
      if (this.options.setOffsetsOnce && this._isOffsetsSet) {
        return;
      }
      this._isOffsetsSet = true;
      this.computeInitialOffset();
      this.resetOffset();
    },
    /**
     * Max / min values for the offset
     * @param offset
     * @return {Object} the sanitized offset
     */
    sanitizeOffset: function(offset) {
      var elWidth = this.el.offsetWidth * this.getInitialZoomFactor() * this.zoomFactor;
      var elHeight = this.el.offsetHeight * this.getInitialZoomFactor() * this.zoomFactor;
      var maxX = elWidth - this.getContainerX() + this.options.horizontalPadding, maxY = elHeight - this.getContainerY() + this.options.verticalPadding, maxOffsetX = Math.max(maxX, 0), maxOffsetY = Math.max(maxY, 0), minOffsetX = Math.min(maxX, 0) - this.options.horizontalPadding, minOffsetY = Math.min(maxY, 0) - this.options.verticalPadding;
      return {
        x: Math.min(Math.max(offset.x, minOffsetX), maxOffsetX),
        y: Math.min(Math.max(offset.y, minOffsetY), maxOffsetY)
      };
    },
    /**
     * Scale to a specific zoom factor (not relative)
     * @param zoomFactor
     * @param center
     */
    scaleTo: function(zoomFactor, center) {
      this.scale(zoomFactor / this.zoomFactor, center);
    },
    /**
     * Scales the element from specified center
     * @param scale
     * @param center
     */
    scale: function(scale, center) {
      scale = this.scaleZoomFactor(scale);
      this.addOffset({
        x: (scale - 1) * (center.x + this.offset.x),
        y: (scale - 1) * (center.y + this.offset.y)
      });
      triggerEvent(this.el, this.options.zoomUpdateEventName);
      if (typeof this.options.onZoomUpdate == "function") {
        this.options.onZoomUpdate(this, event);
      }
    },
    /**
     * Scales the zoom factor relative to current state
     * @param scale
     * @return the actual scale (can differ because of max min zoom factor)
     */
    scaleZoomFactor: function(scale) {
      var originalZoomFactor = this.zoomFactor;
      this.zoomFactor *= scale;
      this.zoomFactor = Math.min(this.options.maxZoom, Math.max(this.zoomFactor, this.options.minZoom));
      return this.zoomFactor / originalZoomFactor;
    },
    /**
     * Determine if the image is in a draggable state
     *
     * When the image can be dragged, the drag event is acted upon and cancelled.
     * When not draggable, the drag event bubbles through this component.
     *
     * @return {Boolean}
     */
    canDrag: function() {
      return this.options.draggableUnzoomed || !isCloseTo(this.zoomFactor, 1);
    },
    /**
     * Drags the element
     * @param center
     * @param lastCenter
     */
    drag: function(center, lastCenter) {
      if (lastCenter) {
        if (this.options.lockDragAxis) {
          if (Math.abs(center.x - lastCenter.x) > Math.abs(center.y - lastCenter.y)) {
            this.addOffset({
              x: -(center.x - lastCenter.x),
              y: 0
            });
          } else {
            this.addOffset({
              y: -(center.y - lastCenter.y),
              x: 0
            });
          }
        } else {
          this.addOffset({
            y: -(center.y - lastCenter.y),
            x: -(center.x - lastCenter.x)
          });
        }
        triggerEvent(this.el, this.options.dragUpdateEventName);
        if (typeof this.options.onDragUpdate == "function") {
          this.options.onDragUpdate(this, event);
        }
      }
    },
    /**
     * Calculates the touch center of multiple touches
     * @param touches
     * @return {Object}
     */
    getTouchCenter: function(touches) {
      return this.getVectorAvg(touches);
    },
    /**
     * Calculates the average of multiple vectors (x, y values)
     */
    getVectorAvg: function(vectors) {
      return {
        x: vectors.map(function(v) {
          return v.x;
        }).reduce(sum) / vectors.length,
        y: vectors.map(function(v) {
          return v.y;
        }).reduce(sum) / vectors.length
      };
    },
    /**
     * Adds an offset
     * @param offset the offset to add
     * @return return true when the offset change was accepted
     */
    addOffset: function(offset) {
      this.offset = {
        x: this.offset.x + offset.x,
        y: this.offset.y + offset.y
      };
    },
    sanitize: function() {
      if (this.zoomFactor < this.options.zoomOutFactor) {
        this.zoomOutAnimation();
      } else if (this.isInsaneOffset(this.offset)) {
        this.sanitizeOffsetAnimation();
      }
    },
    /**
     * Checks if the offset is ok with the current zoom factor
     * @param offset
     * @return {Boolean}
     */
    isInsaneOffset: function(offset) {
      var sanitizedOffset = this.sanitizeOffset(offset);
      return sanitizedOffset.x !== offset.x || sanitizedOffset.y !== offset.y;
    },
    /**
     * Creates an animation moving to a sane offset
     */
    sanitizeOffsetAnimation: function() {
      var targetOffset = this.sanitizeOffset(this.offset), startOffset = {
        x: this.offset.x,
        y: this.offset.y
      }, updateProgress = (function(progress) {
        this.offset.x = startOffset.x + progress * (targetOffset.x - startOffset.x);
        this.offset.y = startOffset.y + progress * (targetOffset.y - startOffset.y);
        this.update();
      }).bind(this);
      this.animate(
        this.options.animationDuration,
        updateProgress,
        this.swing
      );
    },
    /**
     * Zooms back to the original position,
     * (no offset and zoom factor 1)
     */
    zoomOutAnimation: function() {
      if (this.zoomFactor === 1) {
        return;
      }
      var startZoomFactor = this.zoomFactor, zoomFactor = 1, center = this.getCurrentZoomCenter(), updateProgress = (function(progress) {
        this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
      }).bind(this);
      this.animate(
        this.options.animationDuration,
        updateProgress,
        this.swing
      );
    },
    /**
     * Updates the container aspect ratio
     *
     * Any previous container height must be cleared before re-measuring the
     * parent height, since it depends implicitly on the height of any of its children
     */
    updateAspectRatio: function() {
      this.unsetContainerY();
      this.setContainerY(this.container.parentElement.offsetHeight);
    },
    /**
     * Calculates the initial zoom factor (for the element to fit into the container)
     * @return {number} the initial zoom factor
     */
    getInitialZoomFactor: function() {
      var xZoomFactor = this.container.offsetWidth / this.el.offsetWidth;
      var yZoomFactor = this.container.offsetHeight / this.el.offsetHeight;
      return Math.min(xZoomFactor, yZoomFactor);
    },
    /**
     * Calculates the aspect ratio of the element
     * @return the aspect ratio
     */
    getAspectRatio: function() {
      return this.el.offsetWidth / this.el.offsetHeight;
    },
    /**
     * Calculates the virtual zoom center for the current offset and zoom factor
     * (used for reverse zoom)
     * @return {Object} the current zoom center
     */
    getCurrentZoomCenter: function() {
      var offsetLeft = this.offset.x - this.initialOffset.x;
      var centerX = -1 * this.offset.x - offsetLeft / (1 / this.zoomFactor - 1);
      var offsetTop = this.offset.y - this.initialOffset.y;
      var centerY = -1 * this.offset.y - offsetTop / (1 / this.zoomFactor - 1);
      return {
        x: centerX,
        y: centerY
      };
    },
    /**
     * Returns the touches of an event relative to the container offset
     * @param event
     * @return array touches
     */
    getTouches: function(event2) {
      var rect = this.container.getBoundingClientRect();
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      var scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
      var posTop = rect.top + scrollTop;
      var posLeft = rect.left + scrollLeft;
      return Array.prototype.slice.call(event2.touches).map(function(touch) {
        return {
          x: touch.pageX - posLeft,
          y: touch.pageY - posTop
        };
      });
    },
    /**
     * Animation loop
     * does not support simultaneous animations
     * @param duration
     * @param framefn
     * @param timefn
     * @param callback
     */
    animate: function(duration, framefn, timefn, callback) {
      var startTime = (/* @__PURE__ */ new Date()).getTime(), renderFrame = (function() {
        if (!this.inAnimation) {
          return;
        }
        var frameTime = (/* @__PURE__ */ new Date()).getTime() - startTime, progress = frameTime / duration;
        if (frameTime >= duration) {
          framefn(1);
          if (callback) {
            callback();
          }
          this.update();
          this.stopAnimation();
          this.update();
        } else {
          if (timefn) {
            progress = timefn(progress);
          }
          framefn(progress);
          this.update();
          requestAnimationFrame(renderFrame);
        }
      }).bind(this);
      this.inAnimation = true;
      requestAnimationFrame(renderFrame);
    },
    /**
     * Stops the animation
     */
    stopAnimation: function() {
      this.inAnimation = false;
    },
    /**
     * Swing timing function for animations
     * @param p
     * @return {Number}
     */
    swing: function(p) {
      return -Math.cos(p * Math.PI) / 2 + 0.5;
    },
    getContainerX: function() {
      return this.container.offsetWidth;
    },
    getContainerY: function() {
      return this.container.offsetHeight;
    },
    setContainerY: function(y) {
      return this.container.style.height = y + "px";
    },
    unsetContainerY: function() {
      this.container.style.height = null;
    },
    /**
     * Creates the expected html structure
     */
    setupMarkup: function() {
      this.container = buildElement('<div class="pinch-zoom-container"></div>');
      this.el.parentNode.insertBefore(this.container, this.el);
      this.container.appendChild(this.el);
      this.container.style.overflow = "hidden";
      this.container.style.position = "relative";
      this.el.style.webkitTransformOrigin = "0% 0%";
      this.el.style.mozTransformOrigin = "0% 0%";
      this.el.style.msTransformOrigin = "0% 0%";
      this.el.style.oTransformOrigin = "0% 0%";
      this.el.style.transformOrigin = "0% 0%";
      this.el.style.position = "absolute";
    },
    end: function() {
      this.hasInteraction = false;
      this.sanitize();
      this.update();
    },
    /**
     * Binds all required event listeners
     */
    bindEvents: function() {
      var self = this;
      detectGestures(this.container, this);
      this.resizeHandler = this.update.bind(this);
      window.addEventListener("resize", this.resizeHandler);
      Array.from(this.el.querySelectorAll("img")).forEach(function(imgEl) {
        imgEl.addEventListener("load", self.update.bind(self));
      });
      if (this.el.nodeName === "IMG") {
        this.el.addEventListener("load", this.update.bind(this));
      }
    },
    /**
     * Updates the css values according to the current zoom factor and offset
     */
    update: function(event2) {
      if (event2 && event2.type === "resize") {
        this.updateAspectRatio();
        this.setupOffsets();
      }
      if (event2 && event2.type === "load") {
        this.updateAspectRatio();
        this.setupOffsets();
      }
      if (this.updatePlanned) {
        return;
      }
      this.updatePlanned = true;
      window.setTimeout((function() {
        this.updatePlanned = false;
        var zoomFactor = this.getInitialZoomFactor() * this.zoomFactor, offsetX = -this.offset.x / zoomFactor, offsetY = -this.offset.y / zoomFactor, transform3d = "scale3d(" + zoomFactor + ", " + zoomFactor + ",1) translate3d(" + offsetX + "px," + offsetY + "px,0px)", transform2d = "scale(" + zoomFactor + ", " + zoomFactor + ") translate(" + offsetX + "px," + offsetY + "px)", removeClone = (function() {
          if (this.clone) {
            this.clone.parentNode.removeChild(this.clone);
            delete this.clone;
          }
        }).bind(this);
        if (!this.options.use2d || this.hasInteraction || this.inAnimation) {
          this.is3d = true;
          removeClone();
          this.el.style.webkitTransform = transform3d;
          this.el.style.mozTransform = transform2d;
          this.el.style.msTransform = transform2d;
          this.el.style.oTransform = transform2d;
          this.el.style.transform = transform3d;
        } else {
          if (this.is3d) {
            this.clone = this.el.cloneNode(true);
            this.clone.style.pointerEvents = "none";
            this.container.appendChild(this.clone);
            window.setTimeout(removeClone, 200);
          }
          this.el.style.webkitTransform = transform2d;
          this.el.style.mozTransform = transform2d;
          this.el.style.msTransform = transform2d;
          this.el.style.oTransform = transform2d;
          this.el.style.transform = transform2d;
          this.is3d = false;
        }
      }).bind(this), 0);
    },
    /**
     * Enables event handling for gestures
     */
    enable: function() {
      this.enabled = true;
    },
    /**
     * Disables event handling for gestures
     */
    disable: function() {
      this.enabled = false;
    },
    /**
     * Unmounts the zooming container and global event listeners
     */
    destroy: function() {
      window.removeEventListener("resize", this.resizeHandler);
      if (this.container) {
        this.container.remove();
        this.container = null;
      }
    }
  };
  var detectGestures = function(el, target) {
    var interaction = null, fingers = 0, lastTouchStart = null, startTouches = null, setInteraction = function(newInteraction, event2) {
      if (interaction !== newInteraction) {
        if (interaction && !newInteraction) {
          switch (interaction) {
            case "zoom":
              target.handleZoomEnd(event2);
              break;
            case "drag":
              target.handleDragEnd(event2);
              break;
          }
        }
        switch (newInteraction) {
          case "zoom":
            target.handleZoomStart(event2);
            break;
          case "drag":
            target.handleDragStart(event2);
            break;
        }
      }
      interaction = newInteraction;
    }, updateInteraction = function(event2) {
      if (fingers === 2) {
        setInteraction("zoom");
      } else if (fingers === 1 && target.canDrag()) {
        setInteraction("drag", event2);
      } else {
        setInteraction(null, event2);
      }
    }, targetTouches = function(touches) {
      return Array.from(touches).map(function(touch) {
        return {
          x: touch.pageX,
          y: touch.pageY
        };
      });
    }, getDistance = function(a, b) {
      var x, y;
      x = a.x - b.x;
      y = a.y - b.y;
      return Math.sqrt(x * x + y * y);
    }, calculateScale = function(startTouches2, endTouches) {
      var startDistance = getDistance(startTouches2[0], startTouches2[1]), endDistance = getDistance(endTouches[0], endTouches[1]);
      return endDistance / startDistance;
    }, cancelEvent = function(event2) {
      event2.stopPropagation();
      event2.preventDefault();
    }, detectDoubleTap = function(event2) {
      var time = (/* @__PURE__ */ new Date()).getTime();
      if (fingers > 1) {
        lastTouchStart = null;
      }
      if (time - lastTouchStart < 300) {
        cancelEvent(event2);
        target.handleDoubleTap(event2);
        switch (interaction) {
          case "zoom":
            target.handleZoomEnd(event2);
            break;
          case "drag":
            target.handleDragEnd(event2);
            break;
        }
      } else {
        target.isDoubleTap = false;
      }
      if (fingers === 1) {
        lastTouchStart = time;
      }
    }, firstMove = true;
    el.addEventListener("touchstart", function(event2) {
      if (target.enabled) {
        firstMove = true;
        fingers = event2.touches.length;
        detectDoubleTap(event2);
      }
    }, { passive: false });
    el.addEventListener("touchmove", function(event2) {
      if (target.enabled && !target.isDoubleTap) {
        if (firstMove) {
          updateInteraction(event2);
          if (interaction) {
            cancelEvent(event2);
          }
          startTouches = targetTouches(event2.touches);
        } else {
          switch (interaction) {
            case "zoom":
              if (startTouches.length == 2 && event2.touches.length == 2) {
                target.handleZoom(event2, calculateScale(startTouches, targetTouches(event2.touches)));
              }
              break;
            case "drag":
              target.handleDrag(event2);
              break;
          }
          if (interaction) {
            cancelEvent(event2);
            target.update();
          }
        }
        firstMove = false;
      }
    }, { passive: false });
    el.addEventListener("touchend", function(event2) {
      if (target.enabled) {
        fingers = event2.touches.length;
        updateInteraction(event2);
      }
    });
  };
  return PinchZoom2;
};
var PinchZoom = definePinchZoom();
const dom = {};
const selectors = {
  carousel: ".product__media-list",
  thumbListInner: ".desktop-thumb-list-inner",
  thumb: ".desktop-thumb-container",
  thumbList: ".desktop-thumb-list",
  thumbListPrevButton: ".desktop-thumb-list-button--prev",
  thumbListNextButton: ".desktop-thumb-list-button--next",
  zoomContainer: ".desktop-media-zoom .desktop-media-container"
};
const thumbHeight = 72;
let current = 0;
let slideCount = 0;
let visibleThumbs = 0;
const cacheDom = () => {
  dom.carousel = document.querySelector(selectors.carousel);
  dom.thumbListInner = document.querySelector(selectors.thumbListInner);
  dom.thumbs = document.querySelectorAll(selectors.thumb);
  dom.thumbList = document.querySelector(selectors.thumbList);
  dom.thumbListPrevButton = document.querySelector(selectors.thumbListPrevButton);
  dom.thumbListNextButton = document.querySelector(selectors.thumbListNextButton);
  dom.zoomContainer = document.querySelector(selectors.zoomContainer);
};
const bindEvents = () => {
  window.addEventListener("resize", async () => {
    const flkty = await dom.carousel.flickityInstance;
    if (flkty) {
      initThumbSlider();
    }
  });
  dom.carousel && dom.carousel.addEventListener("flickity:ready", () => {
    initThumbSlider();
  });
  dom.zoomContainer.addEventListener("MediaZoomOpened", () => {
    let activeItem = dom.zoomContainer.querySelector(`[data-index="${dom.zoomContainer.dataset.currentIndex}"]`);
    if (activeItem.classList.contains("image-wrapper") && !activeItem.pz) {
      activeItem.pz = new PinchZoom(activeItem.querySelector(".desktop-media-item-inner"), {
        draggableUnzoomed: false,
        minZoom: 1,
        onZoomStart: (obj, evt) => {
          console.log("zoom start");
          dom.zoomContainer.classList.add("is-zooming");
        },
        onZoomEnd: (obj, evt) => {
          console.log("zoom end");
          dom.zoomContainer.classList.remove("is-zooming");
        }
      });
    }
  });
  dom.carousel.addEventListener("flickity:ready", async () => {
    const flkty = await dom.carousel.flickityInstance;
    if (flkty) {
      flkty.cells.forEach((cell, idx) => {
        const imgEl = cell.element.querySelector(".product__media-image-wrapper");
        if (!imgEl) {
          flkty.pageDots.dots[idx].setAttribute("data-video", true);
        }
      });
    }
  });
  dom.thumbs.forEach((thumb) => {
    thumb.addEventListener("click", async (e) => {
      const index = thumb.dataset.index;
      const flkty = await dom.carousel.flickityInstance;
      flkty.select(index);
      dom.thumbs.forEach((el) => el.classList.remove("is-selected"));
      thumb.classList.add("is-selected");
    });
  });
  dom.thumbListPrevButton.addEventListener("click", () => {
    current--;
    if (current < 0) {
      current = 0;
    }
    updateThumbSlider();
  });
  dom.thumbListNextButton.addEventListener("click", () => {
    current++;
    if (current > slideCount) {
      current = slideCount;
    }
    updateThumbSlider();
  });
  dom.thumbList.addEventListener("wheel", (event2) => {
    event2.preventDefault();
    if (event2.deltaY > 0 && current < slideCount) {
      current++;
    } else if (event2.deltaY < 0 && current > 0) {
      current--;
    }
    updateThumbSlider();
  }, { passive: false });
};
const updateThumbSlider = () => {
  updateThumbSliderButtons();
  let idx = current - visibleThumbs + 1;
  if (idx >= 0) {
    dom.thumbList.scrollTo({ top: idx * thumbHeight, behavior: "smooth" });
  }
  dom.thumbs.item(current).click();
};
const initThumbSlider = () => {
  if (dom.thumbList && dom.thumbList.scrollHeight > dom.thumbList.clientHeight) {
    dom.thumbListInner.classList.add("slider");
    slideCount = dom.thumbs.length - 1;
    visibleThumbs = Math.floor(dom.thumbList.clientHeight / thumbHeight);
    updateThumbSliderButtons();
  } else {
    dom.thumbListInner.classList.remove("slider");
    slideCount = 0;
    visibleThumbs = 0;
  }
};
const updateThumbSliderButtons = () => {
  if (current <= 0) {
    dom.thumbListPrevButton.setAttribute("disabled", true);
  } else {
    dom.thumbListPrevButton.removeAttribute("disabled");
  }
  if (current >= slideCount) {
    dom.thumbListNextButton.setAttribute("disabled", true);
  } else {
    dom.thumbListNextButton.removeAttribute("disabled");
  }
};
const productGallery = {
  init() {
    cacheDom();
    bindEvents();
  }
};
document.addEventListener("rebuy.add", () => {
  document.getElementById("mini-cart").open = true;
  fetch("/cart.js").then((r) => r.json()).then((cart) => {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:updated", { bubbles: true, detail: { cart } })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", { bubbles: true, detail: { cart } })
    );
  });
});
document.addEventListener("rebuy.ready", (event2) => {
  var _a;
  const { widget } = event2.detail;
  if (widget.id !== "288541") return;
  const products = (_a = widget.data) == null ? void 0 : _a.products;
  if (!(products == null ? void 0 : products.length)) return;
  function injectDescriptions() {
    const widgetEl2 = document.getElementById(`rebuy-widget-${widget.id}`);
    if (!widgetEl2) return;
    const titles = widgetEl2.querySelectorAll(".rebuy-product-title.clickable");
    titles.forEach((titleEl, index) => {
      var _a2, _b, _c, _d;
      if ((_a2 = titleEl.nextElementSibling) == null ? void 0 : _a2.classList.contains("rebuy-inline-upsell-desc")) return;
      const desc = (_d = (_c = (_b = products[index]) == null ? void 0 : _b.metafields) == null ? void 0 : _c.custom) == null ? void 0 : _d.description_for_inline_upsell;
      if (!desc) return;
      const el = document.createElement("p");
      el.className = "rebuy-inline-upsell-desc";
      el.textContent = desc;
      titleEl.insertAdjacentElement("afterend", el);
    });
  }
  const widgetEl = document.getElementById(`rebuy-widget-${widget.id}`);
  if (widgetEl) {
    injectDescriptions();
    const observer = new MutationObserver(() => {
      injectDescriptions();
    });
    observer.observe(widgetEl, { childList: true, subtree: true });
  }
});
class IngredientHighlights extends HTMLElement {
  constructor() {
    super(...arguments);
    __publicField(this, "thumbList");
    __publicField(this, "thumbs");
    __publicField(this, "textItems");
    __publicField(this, "images");
    __publicField(this, "featuredImages");
    __publicField(this, "isDragging", false);
    __publicField(this, "startX", 0);
    __publicField(this, "startScrollLeft", 0);
    __publicField(this, "init", () => {
      console.log("init");
      this.thumbList = this.querySelector(".whats-inside-section__ingredient-highlight-thumbs");
      this.thumbs = this.querySelectorAll(".whats-inside-section__ingredient-highlight-thumb");
      this.textItems = this.querySelectorAll(".whats-inside-section__ingredient-highlight-text-item");
      this.images = this.querySelectorAll(".whats-inside-section__ingredient-highlight-image");
      this.featuredImages = this.querySelectorAll(".whats-inside-section__ingredient-highlight-featured-image");
      if (this.thumbList) {
        const thumbList = this.thumbList;
        if (window.matchMedia("screen and (min-width: 1024px)").matches) {
          thumbList.addEventListener("mousedown", this.handleMouseDown);
          window.addEventListener("mousemove", this.handleMouseMove);
          window.addEventListener("mouseup", this.handleMouseUp);
        }
        this.thumbs.forEach((thumb) => {
          thumb.addEventListener("click", this.handleThumbClick);
        });
      }
    });
    __publicField(this, "handleThumbClick", (e) => {
      var _a, _b, _c, _d, _e, _f, _g;
      const thumb = e.currentTarget;
      const id = thumb.dataset.id;
      if (!id) return;
      (_a = this.images) == null ? void 0 : _a.forEach((image) => image.classList.add("hidden"));
      (_b = this.images) == null ? void 0 : _b.forEach((image) => {
        if (image.dataset.id == id) image.classList.remove("hidden");
      });
      (_c = this.featuredImages) == null ? void 0 : _c.forEach((image) => image.classList.add("hidden"));
      (_d = this.featuredImages) == null ? void 0 : _d.forEach((image) => {
        if (image.dataset.id == id) image.classList.remove("hidden");
      });
      (_e = this.textItems) == null ? void 0 : _e.forEach((item) => item.classList.add("hidden"));
      (_f = this.textItems) == null ? void 0 : _f.forEach((item) => {
        if (item.dataset.id == id) item.classList.remove("hidden");
      });
      (_g = this.thumbs) == null ? void 0 : _g.forEach((item) => {
        item.classList.toggle("active", item === thumb);
      });
    });
    __publicField(this, "handleMouseDown", (e) => {
      const thumbList = this.thumbList;
      if (!thumbList) return;
      this.isDragging = true;
      this.startX = e.pageX;
      this.startScrollLeft = thumbList.scrollLeft || 0;
      thumbList.classList.add("dragging");
    });
    __publicField(this, "handleMouseMove", (e) => {
      const thumbList = this.thumbList;
      if (!thumbList) return;
      if (!this.isDragging) return;
      const distance = e.pageX - this.startX;
      thumbList.scrollTo({
        left: this.startScrollLeft - distance || 0,
        behavior: "smooth"
      });
    });
    __publicField(this, "handleMouseUp", () => {
      const thumbList = this.thumbList;
      if (!thumbList) return;
      if (!this.isDragging) return;
      this.isDragging = false;
      thumbList.classList.remove("dragging");
    });
  }
  connectedCallback() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", this.init, { once: true });
    } else {
      this.init();
    }
  }
  disconnectedCallback() {
    var _a;
    if (this.thumbList) {
      if (window.matchMedia("screen and (min-width: 1024px)").matches) {
        this.thumbList.removeEventListener("mousedown", this.handleMouseDown);
        window.removeEventListener("mousemove", this.handleMouseMove);
        window.removeEventListener("mouseup", this.handleMouseUp);
      }
      (_a = this.thumbs) == null ? void 0 : _a.forEach((thumb) => {
        thumb.removeEventListener("click", this.handleThumbClick);
      });
    }
  }
}
if (!customElements.get("ingredient-highlights")) {
  customElements.define("ingredient-highlights", IngredientHighlights);
}
class MarqueeScroller extends HTMLElement {
  constructor() {
    super(...arguments);
    __publicField(this, "speed", 30);
    // pixels per second
    __publicField(this, "rafId");
    __publicField(this, "lastTime");
    __publicField(this, "paused", false);
    __publicField(this, "running", false);
    __publicField(this, "loopWidth", 0);
    __publicField(this, "offset", 0);
    __publicField(this, "track");
    __publicField(this, "resizeObserver");
    __publicField(this, "tick", (time) => {
      if (this.lastTime === void 0) this.lastTime = time;
      const delta = Math.min((time - this.lastTime) / 1e3, 0.05);
      this.lastTime = time;
      if (!this.paused && this.loopWidth > 0 && this.track) {
        this.offset += this.speed * delta;
        if (this.offset >= this.loopWidth) {
          this.offset -= this.loopWidth;
        }
        this.track.style.transform = `translate3d(${-this.offset}px, 0, 0)`;
      }
      this.rafId = requestAnimationFrame(this.tick);
    });
    __publicField(this, "pause", () => {
      this.paused = true;
    });
    __publicField(this, "resume", () => {
      this.paused = false;
      this.lastTime = void 0;
    });
    __publicField(this, "init", () => {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      this.track = this.querySelector(":scope > .marquee-scroller__track") ?? void 0;
      this.checkMarquee();
      this.resizeObserver = new ResizeObserver(this.checkMarquee);
      this.resizeObserver.observe(this);
    });
    __publicField(this, "getOriginalItems", () => {
      const parent = this.track ?? this;
      return Array.from(parent.children).filter(
        (child) => child instanceof HTMLElement && !child.classList.contains("cloned")
      );
    });
    __publicField(this, "getChildrenWidth", () => {
      const items = this.getOriginalItems();
      if (items.length === 0) return 0;
      const parent = this.track ?? this;
      const gap = parseFloat(getComputedStyle(parent).columnGap) || 0;
      const width = items.reduce((sum, child) => sum + child.getBoundingClientRect().width, 0);
      return width + gap * Math.max(0, items.length - 1);
    });
    __publicField(this, "measureLoopWidth", () => {
      if (!this.track) return 0;
      const first = this.getOriginalItems()[0];
      const firstClone = this.track.querySelector(":scope > .cloned");
      if (!first || !firstClone) return 0;
      return firstClone.offsetLeft - first.offsetLeft;
    });
    __publicField(this, "checkMarquee", () => {
      this.updateSpeed();
      if (this.clientWidth >= this.getChildrenWidth()) {
        this.stopAnimation();
      } else {
        this.initAnimation();
      }
    });
    __publicField(this, "updateSpeed", () => {
      let attr = 1e3;
      if (window.matchMedia("screen and (min-width: 1024px)").matches) {
        attr = Number(this.getAttribute("data-speed"));
      } else {
        attr = Number(this.getAttribute("data-speed-mobile"));
      }
      if (attr > 0) this.speed = 30 * 1e3 / attr;
    });
    __publicField(this, "initAnimation", () => {
      const parent = this.track ?? this;
      const items = this.getOriginalItems();
      if (items.length === 0) return;
      if (this.running) {
        this.loopWidth = this.measureLoopWidth();
        return;
      }
      this.running = true;
      items.forEach((item) => {
        const icon = item.querySelector(".whats-inside-section__no-list-item-icon");
        if (icon == null ? void 0 : icon.classList.contains("hidden")) {
          icon.style.display = "block";
        }
        const clone = item.cloneNode(true);
        clone.classList.add("cloned");
        parent.appendChild(clone);
      });
      this.offset = 0;
      if (this.track) this.track.style.transform = "translate3d(0, 0, 0)";
      this.addEventListener("mouseenter", this.pause);
      this.addEventListener("mouseleave", this.resume);
      this.addEventListener("focusin", this.pause);
      this.addEventListener("focusout", this.resume);
      this.addEventListener("touchstart", this.pause, { passive: true });
      this.addEventListener("touchend", this.resume, { passive: true });
      this.addEventListener("touchcancel", this.resume, { passive: true });
      document.addEventListener("visibilitychange", this.handleVisibility);
      requestAnimationFrame(() => {
        if (!this.running) return;
        this.loopWidth = this.measureLoopWidth();
        this.rafId = requestAnimationFrame(this.tick);
      });
    });
    __publicField(this, "stopAnimation", () => {
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.running = false;
      this.rafId = void 0;
      this.loopWidth = 0;
      this.offset = 0;
      this.lastTime = void 0;
      if (this.track) this.track.style.transform = "";
      const parent = this.track ?? this;
      parent.querySelectorAll(":scope > .cloned").forEach((clone) => parent.removeChild(clone));
      this.querySelectorAll(".whats-inside-section__no-list-item-icon").forEach((icon) => {
        if (icon.classList.contains("hidden")) {
          icon.style.display = "";
        }
      });
      this.removeEventListener("mouseenter", this.pause);
      this.removeEventListener("mouseleave", this.resume);
      this.removeEventListener("focusin", this.pause);
      this.removeEventListener("focusout", this.resume);
      this.removeEventListener("touchstart", this.pause);
      this.removeEventListener("touchend", this.resume);
      this.removeEventListener("touchcancel", this.resume);
      document.removeEventListener("visibilitychange", this.handleVisibility);
    });
    __publicField(this, "handleVisibility", () => {
      this.paused = document.hidden;
      this.lastTime = void 0;
    });
  }
  connectedCallback() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", this.init, { once: true });
    } else {
      this.init();
    }
  }
  disconnectedCallback() {
    var _a;
    this.stopAnimation();
    (_a = this.resizeObserver) == null ? void 0 : _a.disconnect();
    document.removeEventListener("DOMContentLoaded", this.init);
  }
}
if (!customElements.get("marquee-scroller")) {
  customElements.define("marquee-scroller", MarqueeScroller);
}
document.addEventListener("DOMContentLoaded", () => {
  document.body.addEventListener("click", (event2) => {
    const checkoutBtnEl = document.querySelector("#mini-cart .checkout-button");
    const containerEl = event2.target.closest("._si-widget-container");
    if (containerEl) {
      const siPriceEl = containerEl.querySelector("._si-info-widget-price");
      if (siPriceEl) {
        containerEl.classList.toggle("si-inactive");
        let currentPrice = parseFloat(checkoutBtnEl.textContent.split("|").reverse()[0].replace("$", ""));
        let siPrice = parseFloat(siPriceEl.textContent.replace("$", ""));
        let newPrice = containerEl.classList.contains("si-inactive") ? currentPrice - siPrice : currentPrice + siPrice;
        let newText = checkoutBtnEl.textContent.replace(currentPrice.toString(), newPrice.toString());
        checkoutBtnEl.textContent = newText;
        checkoutBtnEl.setAttribute("value", newText);
      }
    }
    if (event2.target == checkoutBtnEl) {
      const containerEl2 = event2.target.previousElementSibling;
      if (containerEl2.classList.contains("si-inactive")) {
        event2.stopImmediatePropagation();
        event2.stopPropagation();
        const siCheckoutBtnEl = event2.target.parentElement.querySelector("#_si-sec-checkout-id");
        siCheckoutBtnEl && siCheckoutBtnEl.click();
      }
    }
  }, { capture: true });
});
document.addEventListener("galleryUpdated", () => {
  productGallery.init();
});
